<div class="flex gap-2 items-center w-full">
	<p [class]="labelClass">Order date</p>
	<div class="flex flex-1 gap-2">
		<app-date-picker
			[ngModel]="orderedOn"
			(ngModelChange)="setOrderedOn($event)"
			[testHook]="testHooks.OrderedOnDatePicker"
		></app-date-picker>
		<!-- this div is intentional -->
		<div class="w-5"></div>
	</div>
</div>
